import { render, staticRenderFns } from "./CsSpecialApprovePreview.vue?vue&type=template&id=c53f2612"
import script from "./CsSpecialApprovePreview.vue?vue&type=script&lang=js"
export * from "./CsSpecialApprovePreview.vue?vue&type=script&lang=js"
import style0 from "./CsSpecialApprovePreview.vue?vue&type=style&index=0&id=c53f2612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports